
export const heTranslations = {
    // Header
    'nav.home': 'בית',
    'nav.services': 'שירותים',
    'nav.products': 'מוצרים',
    'nav.customization': 'התאמה אישית',
    'nav.superSupport': 'תמיכה סופר',
    'nav.about': 'אודות',
    'nav.team': 'צור קשר',
    'nav.blog': 'בלוג',
    
    // Customization Section
    'customization.title': 'הרחבות מותאמות אישית',
    'customization.subtitle': 'אנחנו מפתחים מה שחסר לך',
    'customization.intro1': 'התוכנה שלנו כבר מכסה את התהליכים החשובים ביותר. אבל לכל עסק יש דרישות משלו – וזה בדיוק מה שאנו מציעים התאמה אישית.',
    'customization.intro2': 'אנו מפתחים פונקציות, מודולים ואינטגרציות אינדיבידואליים המותאמים בדיוק לצרכים שלך. מהיר, מקצועי ומשולב באופן מלא במערכת שלך.',
    'customization.intro3': 'בין אם תוספת קטנה או מודול חדש גדול – אנחנו דואגים שהתוכנה שלך תתאים בדיוק לעסק שלך.',
    'customization.whatWeCanDo': 'מה אנחנו יכולים להרחיב או לפתח עבורך',
    'customization.individualFunctions': 'פונקציות אינדיבידואליות',
    'customization.newModules': 'מודולים ותהליכי עבודה חדשים',
    'customization.processExtensions': 'הרחבות לתהליכים קיימים',
    'customization.automations': 'אוטומציות לפי הדרישות שלך',
    'customization.workflows': 'תהליכי עבודה מותאמים',
    'customization.notifications': 'מערכות התראות',
    'customization.dataValidation': 'אימות ובדיקת נתונים',
    'customization.interfaces': 'ממשקים ואינטגרציות',
    'customization.apiConnections': 'חיבורי API',
    'customization.paymentIntegrations': 'אינטגרציות תשלום',
    'customization.accessIntegrations': 'אינטגרציות גישה או חומרה',
    'customization.thirdPartySystems': 'מערכות צד שלישי',
    'customization.cloudServices': 'חיבור שירותי ענן',
    'customization.dataSync': 'סנכרון נתונים',
    'customization.designUi': 'עיצוב וממשק משתמש',
    'customization.individualLayouts': 'פריסות אינדיבידואליות או התאמות ממשק',
    'customization.documentLayouts': 'פריסות מסמכים וחשבוניות מותאמות',
    'customization.brandingDesign': 'מיתוג ועיצוב תאגידי',
    'customization.mobileOptimization': 'אופטימיזציה למובייל',
    'customization.accessibilityFeatures': 'תכונות נגישות',
    'customization.darkMode': 'מצב כהה ועיצובים',
    'customization.reportsAnalytics': 'דוחות וניתוחים',
    'customization.individualStats': 'סטטיסטיקות וייצוא אינדיבידואליים',
    'customization.dashboardCharts': 'תרשימי לוח בקרה מורחבים',
    'customization.specialReports': 'דוחות וניתוחים מיוחדים',
    'customization.scheduledReports': 'דוחות אוטומטיים',
    'customization.dataExports': 'ייצוא נתונים (CSV, PDF, Excel)',
    'customization.kpiTracking': 'מעקב KPI ומדדים',
    'customization.whyCustomersLove': 'למה לקוחות אוהבים את ההרחבות שלנו',
    'customization.individual': 'אינדיבידואלי',
    'customization.individualDesc': 'מותאם בדיוק לתהליכים שלך',
    'customization.seamless': 'משולב בצורה חלקה',
    'customization.seamlessDesc': 'עובד כחלק טבעי מהמערכת',
    'customization.fastImplementation': 'יישום מהיר',
    'customization.fastImplementationDesc': 'תיאום ישיר ונתיבים קצרים',
    'customization.professional': 'מתועד באופן מקצועי',
    'customization.professionalDesc': 'קוד נקי וניתן לתחזוקה',
    'customization.futureProof': 'עמיד בעתיד',
    'customization.futureProofDesc': 'תואם לעדכונים עתידיים',
    'customization.howItWorks': 'איך פועלת הרחבה',
    'customization.step1Title': 'פגישת דרישות',
    'customization.step1Desc': 'אתה מסביר מה אתה צריך – אנחנו מייעצים לך טכנית.',
    'customization.step2Title': 'הצעת מחיר והערכת מאמץ',
    'customization.step2Desc': 'שקוף ומובן.',
    'customization.step3Title': 'יישום והתקנה',
    'customization.step3Desc': 'פיתוח, בדיקות, אינטגרציה ומסירה.',
    'customization.step4Title': 'תמיכה והמשך פיתוח',
    'customization.step4Desc': 'תחזוקה והתאמות נוספות.',
    'customization.ctaTitle': 'אנחנו מפתחים מה שחסר לך',
    'customization.ctaDesc': 'בין אם תוספת קטנה או מודול חדש גדול – אנחנו דואגים שהתוכנה שלך תתאים בדיוק לעסק שלך.',
    'customization.ctaButton': 'צור קשר לקבלת הצעת מחיר מותאמת',
    
    // Super Support Section
    'superSupport.title': 'תמיכה סופר',
    'superSupport.subtitle': 'אנחנו כאן בשבילך – אישי, מהיר ומקצועי',
    'superSupport.intro1': 'תוכנה טובה רק כמו התמיכה שמאחוריה. ב-Initso לא מקבלים תמיכה סטנדרטית אנונימית, אלא עזרה מומחית אמיתית בכל עת שאתה צריך.',
    'superSupport.intro2': 'אנחנו לא רק עוזרים לך עם בעיות – אנחנו חושבים יחד, מוצאים פתרונות ותומכים בך באופן פעיל להפוך את העסק שלך ליעיל יותר.',
    'superSupport.whatMakesUsSpecial': 'מה עושה את התמיכה שלנו יוצאת דופן',
    'superSupport.directContact': 'קשר ישיר',
    'superSupport.directContactDesc': 'ללא מוקדים טלפוניים, ללא העברות – אתה מדבר ישירות עם מומחים שמכירים את המערכת.',
    'superSupport.fastResponse': 'זמני תגובה מהירים',
    'superSupport.fastResponseDesc': 'אנחנו מגיבים לפניות בדרך כלל תוך מספר ימים או אפילו שעות, בהתאם למורכבות.',
    'superSupport.proactiveHelp': 'עזרה יזומה',
    'superSupport.proactiveHelpDesc': 'אנחנו פונים אליך כשאנו מזהים אי-סדרים, תומכים בהתאמות ומייעצים לגבי אופטימיזציות.',
    'superSupport.clearSolutions': 'פתרונות ברורים ומובנים',
    'superSupport.clearSolutionsDesc': 'אנחנו מסבירים בבהירות, פותרים בעיות באמינות ומוודאים שהכל עובד חלק.',
    'superSupport.setupTraining': 'תמיכה בהתקנה והדרכה',
    'superSupport.setupTrainingDesc': 'אנחנו עוזרים בהתחלה, מגדירים את המערכת שלך ומכשירים את הצוות שלך.',
    'superSupport.yourSuccessTitle': 'ההצלחה שלך היא המטרה שלנו',
    'superSupport.yourSuccessDesc1': 'עם Initso אתה לא רק מקבל מערכת חזקה, אלא שותף חזק לצידך.',
    'superSupport.yourSuccessDesc2': 'אנחנו דואגים שהעסק שלך יהיה נתמך באופן מקצועי בכל עת.',
    
    // Hero
    'hero.title': 'פתרונות IT חדשניים לעסקים מודרניים',
    'hero.subtitle': 'אנו עוזרים לעסקים להתמיר ולצמוח באמצעות טכנולוגיה.',
    'hero.cta': 'התחל עכשיו',
    'hero.professional.initso': 'INITSO',
    'hero.professional.line1': 'שותף ה-IT האישי שלך',
    'hero.professional.line2': 'בשווייץ',
    'hero.comprehensive': 'אנו מספקים פתרונות ושירותי IT מקיפים כדי לעזור לעסקים לצמוח, לייעל תהליכים ולהישאר מאובטחים בעולם הדיגיטלי.',
    'hero.services': 'השירותים שלנו',
    'hero.contactus': 'צור קשר',
    'hero.tryGymSoftware': 'נסה תוכנת חדר כושר',
    // Services
    'services.title': 'השירותים שלנו',
    'services.description': 'אנו מציעים פתרונות IT מקיפים כדי לעזור לעסקים לשגשג בנוף הדיגיטלי. מייעוץ אסטרטגי ועד ליישום טכני, השירותים שלנו מיועדים לענות על הצרכים שלך.',
    'services.consulting.title': 'ייעוץ IT',
    'services.consulting.description': 'הדרכה מומחית שתעזור לך לקבל החלטות טכנולוגיות אסטרטגיות המתואמות עם יעדי העסק שלך.',
    'services.consulting.feature1': 'הערכת טכנולוגיה',
    'services.consulting.feature2': 'טרנספורמציה דיגיטלית',
    'services.consulting.feature3': 'תכנון אסטרטגיית IT',
    'services.consulting.feature4': 'אופטימיזציית תהליכים',
    'services.integration.title': 'אינטגרציית מערכות',
    'services.integration.description': 'חיבור חלק של היישומים והמערכות שלך לשיפור היעילות וזרימת הנתונים.',
    'services.integration.feature1': 'פיתוח API',
    'services.integration.feature2': 'אינטגרציית מערכות ישנות',
    'services.integration.feature3': 'פתרונות אינטגרציית ענן',
    'services.integration.feature4': 'עיצוב ארכיטקטורת מערכת',
    'services.software.title': 'תוכנה מותאמת אישית',
    'services.software.description': 'פתרונות תוכנה מותאמים במיוחד לדרישות העסקיות הייחודיות שלך.',
    'services.software.feature1': 'פיתוח יישומים מותאמים',
    'services.software.feature2': 'פיתוח אפליקציות מובייל',
    'services.software.feature3': 'יישומי אינטרנט',
    'services.software.feature4': 'תחזוקת תוכנה',
    'services.support.title': 'ניהול פרויקטים',
    'services.support.description': 'שירותי ניהול פרויקטים מקיפים המותאמים במיוחד לצרכים של פרויקטי תוכנה.',
    'services.support.feature1': 'התחלה מקצועית',
    'services.support.feature2': 'תכנון אסטרטגי',
    'services.support.feature3': 'ביצוע יעיל',
    'services.support.feature4': 'סיום מוצלח',
    // Products
    'products.title': 'המוצרים שלנו',
    'products.description': 'גלה את מגוון המוצרים החדשניים שלנו שתוכננו לשפר את פעולות העסק והנוכחות הדיגיטלית שלך.',
    'products.features': 'תכונות מפתח',
    'products.learnMore': 'למד עוד',
    'products.prop': 'Propertyprofi',
    'products.prop.description': 'פתרונות תוכנה מבוססי ענן לעסקים מודרניים עם כלים משולבים לניהול פרויקטים, יחסי לקוחות וניתוח נתונים.',
    'products.gym': 'חדר כושר',
    'products.gym.description': 'תוכנת ניהול מקיפה לחדרי כושר. עתיד ניהול חדרי כושר',
    'products.web': 'אתר אינטרנט',
    'products.web.description': 'הנתונים שלך, ההצלחה שלך - שחרר את הפוטנציאל שלך. מומחי עיצוב אתרים יצירתיים, ניהול נתונים יעיל ואינטגרציה חלקה של חנות אינטרנט עם מערכות תשלום דרך ה-API שלנו',
    'products.portal': 'פורטל לקוחות',
    'products.portal.description': 'כל העסקאות של שותפי העסקים וההזמנות של הלקוחות בכלי ענן ברור ומאובטח',
    // Features
    'feature.individual': 'ניתן להתאמה אישית',
    'feature.member': 'ניהול חברים',
    'feature.bill': 'חשבוניות',
    'feature.integration': 'אינטגרציות',
    'feature.report': 'דוחות',
		'feature.access': 'בקרת גישה',
		
		// Marquee Features
		'feature.memberManagement': 'ניהול חברים',
		'feature.invoicing': 'הנפקת חשבוניות',
		'feature.billing595': 'חיוב לפי 595',
		'feature.accessControl': 'בקרת כניסה',
		'feature.reportGeneration': 'יצירת דוחות',
		'feature.analytics': 'ניתוח',
		'feature.onlineRegistration': 'רישום מקוון',
		'feature.customerCommunication': 'תקשורת לקוחות',
		'feature.changeHistory': 'היסטוריית שינויים',
		'feature.subscriptionManagement': 'ניהול מנויים',
		'feature.subscriptionPause': 'השהיית מנוי',
		'feature.installmentPayments': 'תשלומים בתשלומים',

		'feature.crm': 'CRM',
		'feature.management': 'ניהול נכסים',
		'feature.accounting': 'הנהלת חשבונות',
		'feature.document': 'ארכיון מסמכים',
		'feature.insurance': 'ניהול ביטוחים',

    'feature.creativ': 'עיצוב אתרים רספונסיבי יצירתי',
    'feature.custom': 'פתרונות אתר מותאמים אישית',
    'feature.data': 'ניהול נתונים יעיל',
    'feature.api': 'חיבורי API',
    'feature.responsive': 'עיצוב אתרים רספונסיבי',

    'feature.application': 'עיבוד בקשות יעיל',
    'feature.visualization': 'ויזואליזציית נתונים',
    'feature.customer': 'שירות לקוחות מקצועי',
    'feature.productivity': 'הגברת פרודוקטיביות',
    
    'feature.scalable': 'ארכיטקטורת ענן מדרגית',
    'feature.realtime': 'כלי שיתוף פעולה בזמן אמת',
    'feature.backup': 'גיבוי נתונים אוטומטי',
    'feature.security': 'פרוטוקולי אבטחה מתקדמים',
    'feature.predictive': 'ניתוח תחזיתי',
    'feature.reporting': 'דיווח אוטומטי',
    'feature.kpi': 'מעקב KPI מותאם אישית',
    'feature.dataIntegration': 'שילוב נתונים ממקורות מרובים',
    'feature.monitoring': 'ניטור איומים בזמן אמת',
    'feature.intrusion': 'מערכות זיהוי חדירה',
    'feature.encryption': 'פרוטוקולי הצפנת נתונים',
    'feature.compliance': 'ביקורות ציות אבטחה',
    'feature.updates': 'עדכוני אבטחה אוטומטיים',
    'feature.pipelines': 'צנרות CI/CD אוטומטיות',
    'feature.code': 'מדדי איכות קוד',
    'feature.collaborative': 'סביבת פיתוח שיתופית',
    'feature.version': 'שילוב בקרת גרסאות',
    'feature.container': 'תהליכי עבודה של פיתוח מכולות',
    // About
    'about.title': 'אודותינו',
    'about.description': 'אנו צוות של אנשי מקצוע מסורים המחויבים לספק פתרונות IT יוצאי דופן.',
    'about.aboutinitso': 'אודות initso.ch',
    'about.leadingprovider': 'initso.ch הוא ספק שירותי IT מוביל הממוקם בשוויץ, המוקדש לאספקת פתרונות טכנולוגיים באיכות גבוהה לעסקים מכל הגדלים.',
    'about.experience': 'עם שנים של ניסיון וצוות של אנשי מקצוע מיומנים, אנו מציעים שירותי IT מקיפים החל מייעוץ ופיתוח ועד לתחזוקה ותמיכה. המיקוד שלנו הוא על יצירת פתרונות מותאמים אישית העונים על צרכים עסקיים ספציפיים ומניעים צמיחה.',
    'about.mission': 'המשימה שלנו',
    'about.mission.description': 'להעצים עסקים באמצעות פתרונות טכנולוגיים חדשניים.',
    'about.vision': 'החזון שלנו',
    'about.vision.description': 'להיות שותף הטכנולוגיה המהימן לעסקים ברחבי שוויץ.',
    'about.quality': 'איכות',
    'about.quality.description': 'אנו מסתמכים על תקני איכות הגבוהים ביותר בכל הפרויקטים והפתרונות שלנו כדי להשיג תוצאות בנות קיימא עבור הלקוחות שלנו. כל פרט נבדק ומותאם בקפידה כך שהפתרונות שלנו לא רק פונקציונליים, אלא גם אמינים ועתידיים.',
    'about.innovation': 'חדשנות',
    'about.innovation.description': 'טכנולוגיות מודרניות וגישות יצירתיות מאפשרות לנו לפתח פתרונות חדשניים לאתגרים של הלקוחות שלנו. אנו תמיד נשארים בקצב הזמנים ומשלבים את ההתפתחויות העדכניות ביותר בעבודתנו כדי ליצור פתרונות מותאמים אישית.',
		// Testimonials
			'testimonials.title': 'Testimonials',
    // Contact
    'contact.title': 'צור קשר',
    'contact.description': 'מוכנים לשנות את העסק שלכם באמצעות טכנולוגיה? צרו קשר עם הצוות שלנו.',
    'contact.form.name': 'השם שלך',
    'contact.form.email': 'האימייל שלך',
    'contact.form.message': 'ההודעה שלך',
		'contact.messagePlaceholder': 'אנא צרו איתי קשר.',
    'contact.form.submit': 'שלח הודעה',
    'contact.sending': 'שולח...',
    'contact.info.address': 'כתובת',
    'contact.info.email': 'אימייל',
    'contact.info.phone': 'טלפון',
		'contact.messageSent':'ההודעה נשלחה',
		'contact.thankYou':"תודה שפנית אלינו. נחזור אליך בקרוב!",
		'contact.error':'שגיאה',
		'contact.errorMessage':'אירעה בעיה בשליחת ההודעה שלך. אנא נסה שוב.',
		'contact.contactInfo': 'פרטי קשר',
		'contact.businessHours': 'שעות פתיחה',
		'contact.businessHoursValue': '09:00-18:00',
		'contact.weekdays': 'ימי חול',
		'contact.weekend': 'סוף שבוע',
		'contact.closed': 'סגור',
    // Footer
    'footer.newsletter': 'הירשמו לnewsletter שלנו לעדכונים ותובנות.',
    'footer.subscribe': 'הירשמו',
    'footer.rights': 'כל הזכויות שמורות.',
    'footer.services': 'שירותים',
    'footer.itconsulting': 'ייעוץ IT',
    'footer.systemintegration': 'אינטגרציית מערכות',
    'footer.customsoftware': 'תוכנה מותאמת אישית',
    'footer.itsupport': 'תמיכת IT',
    'footer.cloudservices': 'שירותי ענן',
    'footer.company': 'חברה',
    'footer.aboutus': 'אודותינו',
    'footer.careers': 'קריירה',
    'footer.blog': 'בלוג',
    'footer.privacy': 'מדיניות פרטיות',
    'footer.terms': 'תנאי שירות',
    'footer.youremail': 'האימייל שלך',
		'footer.error': "שגיאה",
		'footer.validEmail': 'אנא הזן כתובת אימייל תקינה',
		'footer.subscribed': "נרשמת!",
    'footer.thankYou':"תודה שנרשמת לניוזלטר שלנו.",
		'footer.errorMessage':"אירעה בעיה בהרשמה שלך. אנא נסה שוב.",
    // Product Detail Pages - Basic translations for Hebrew
    'gym.title': 'ניהול חדר כושר',
    'gym.subtitle': 'תוכנת ניהול חדר כושר כל-באחד. העתיד של ניהול חדר כושר - מודרני, יעיל וידידותי למשתמש.',
    'gym.heroIntro': 'תוכנת ניהול חדר כושר All-in-one',
    'gym.cloudBased': '100% מבוססת ענן',
    'gym.readyOn': 'מוכנה לשימוש על',
    'gym.backToOverview': 'חזרה לסקירה',
    'gym.navFeatures': 'תכונות ראשיות',
    'gym.navShowcase': 'מבט',
    'gym.navPricing': 'תמחור',
    'gym.navAllFeatures': 'כל התכונות',
    'gym.navWhyUs': 'למה אנחנו',
    'gym.mainFeatures': 'תכונות ראשיות',
    'gym.featuresDescription': 'תוכנת ניהול חדר הכושר שלנו מציעה את כל הפונקציות הדרושות להפעלה מוצלחת של חדר הכושר שלך, כולל חיוב לפי 595.',
    'gym.customizable': 'ניתן להתאמה אישית',
    'gym.customizableDesc': 'התאם את התוכנה לצרכים שלך. תצורה גמישה לכל סוג של חדר כושר.',
    'gym.memberManagement': 'ניהול חברים',
    'gym.memberManagementDesc': 'ניהול מלא של החברים שלך עם פרופילים, חוזים, היסטוריית אימונים ונתונים אישיים.',
    'gym.invoicing': 'חשבוניות',
    'gym.invoicingDesc': 'יצירת חשבוניות אוטומטית ועיבוד תשלומים עם שיטות תשלום שונות ותזכורות.',
    'gym.billing595': 'חיוב לפי 595',
    'gym.billing595Desc': 'אנו תומכים בחיוב לפי 595 ישירות בתוך תוכנת ניהול חדר הכושר - בצורה ברורה, מרכזית ומתאימה לתהליכי החשבוניות שלך.',
    'gym.billing595ImageAlt': 'תצוגת חשבוניות עבור חיוב לפי 595 בתוכנת ניהול חדר כושר',
    'gym.onlineRegistrationImageAlt': 'רישום מקוון בתוכנת ניהול חדר כושר',
    'gym.memberManagementImageAlt': 'ניהול חברים בתוכנת ניהול חדר כושר',
    'gym.invoicingImageAlt': 'חשבוניות בתוכנת ניהול חדר כושר',
    'gym.billing595FeatureImageAlt': 'חיוב לפי 595 בתוכנת ניהול חדר כושר',
    'gym.integrationsImageAlt': 'אינטגרציות בתוכנת ניהול חדר כושר',
    'gym.reportsImageAlt': 'דוחות וניתוחים בתוכנת ניהול חדר כושר',
    'gym.accessControlImageAlt': 'בקרת כניסה 24/7 בתוכנת ניהול חדר כושר',
    'gym.customizableImageAlt': 'תוכנת ניהול חדר כושר הניתנת להתאמה אישית',
    'gym.subscriptionManagementImageAlt': 'ניהול מנויים בתוכנת ניהול חדר כושר',
    'gym.customerCommunicationImageAlt': 'תקשורת לקוחות בתוכנת ניהול חדר כושר',
    'gym.integrations': 'אינטגרציות',
    'gym.integrationsDesc': 'אינטגרציה חלקה עם מערכות וציוד קיימים לחוויה מאוחדת.',
    'gym.reports': 'דוחות',
    'gym.reportsDesc': 'דוחות ניתוחים מקיפים על מספר חברים, הכנסות, ניצולת ו-KPIs נוספים רבים.',
    'gym.accessControl': 'בקרת גישה 24/7',
    'gym.accessControlDesc': 'בקרת גישה מודרנית עם כרטיסי חברות דיגיטליים ומעקב נוכחות אוטומטי.',
    'gym.onlineRegistration': 'רישום מקוון',
    'gym.onlineRegistrationDesc': 'אפשר לחברים שלך להירשם באופן מקוון בנוחות 24/7 - מהיר, פשוט ובטוח.',
    'gym.subscriptionManagement': 'ניהול מנויים',
    'gym.subscriptionManagementDesc': 'נהל את כל המנויים באופן מרכזי - משינויי חוזה ועד חידושים וביטולים אוטומטיים.',
    'gym.customerCommunication': 'תקשורת עם לקוחות',
    'gym.customerCommunicationDesc': 'הישאר בקשר עם החברים שלך באמצעות כלי תקשורת משולבים לניוזלטרים, התראות והודעות אישיות.',
    'gym.showcaseTitle': 'מבט על ניהול חדר כושר',
    'gym.showcase1Title': 'ניהול חברים',
    'gym.showcase1Desc': 'עם סקירת הלקוחות האינטואיטיבית שלנו תשמור על כל המידע החשוב על הלקוחות שלך תמיד בהישג יד. באמצעות פונקציות חיפוש מהירות ומדויקות תמצא מה שאתה צריך תוך זמן קצר.',
    'gym.showcase2Title': 'רישום מקוון',
    'gym.showcase2Desc': 'רשום חברים חדשים ומעוניינים בגמישות באינטרנט או ישירות במקום. בין אם דרך מחשב נייד, טאבלט או סמארטפון - ההרשמה קלה וניתנת לביצוע מכל מקום.',
    'gym.showcase3Title': 'דיווח וניתוח',
    'gym.showcase3Desc': 'דוחות וניתוחים מפורטים להחלטות עסקיות טובות יותר ואופטימיזציה של הצלחה. פשט את עיבוד התשלומים שלך וחסוך זמן יקר.',
    'gym.showcase4Title': 'חיוב לפי 595',
    'gym.showcase4Desc': 'INITSO מציעה חיוב לפי 595 כחלק ברור מניהול הסטודיו הדיגיטלי, כדי לראות חשבוניות, יתרות פתוחות וסטטוס תשלום במקום מרכזי אחד.',
    'gym.whyOurSoftware': 'למה התוכנה שלנו לחדר כושר?',
    'gym.timeSaving': 'חיסכון בזמן',
    'gym.timeSavingDesc': 'הפוך משימות חוזרות לאוטומטיות והתמקד במה שחשוב - החברים שלך.',
    'gym.increasedEfficiency': 'יעילות מוגברת',
    'gym.increasedEfficiencyDesc': 'בצע אופטימיזציה לתהליכים התפעוליים שלך והפחת מאמץ אדמיניסטרטיבי באופן משמעותי.',
    'gym.betterMemberExperience': 'חוויית חבר טובה יותר',
    'gym.betterMemberExperienceDesc': 'הצע לחברים שלך שירותים דיגיטליים מודרניים ושפר את שביעות רצון הלקוחות.',
    'gym.dataBasedDecisions': 'החלטות מבוססות נתונים',
    'gym.dataBasedDecisionsDesc': 'קבל החלטות עסקיות מושכלות המבוססות על נתונים וניתוחים משמעותיים.',
    'gym.readyForFuture': 'מוכן לעתיד של ניהול חדר כושר?',
    'gym.readyForFutureDesc': 'תן למומחים שלנו להראות לך איך תוכנת ניהול חדר הכושר שלנו יכולה לחולל מהפכה בחדר הכושר שלך.',
    'gym.requestDemo': 'בקש הדגמה',
    'gym.pricing': 'תמחור',
    'gym.pricingDesc': 'מחירים הוגנים לכל גודל סטודיו - התחל היום',
    'gym.pricingTier1': 'בסיסי',
    'gym.pricingTier1Members': 'עד 100 חברים',
    'gym.pricingTier2': 'מתקדם',
    'gym.pricingTier2Members': '100 - 500 חברים',
    'gym.pricingTier3': 'מקצועי',
    'gym.pricingTier3Members': '500 - 1000 חברים',
    'gym.pricingTier4': 'עסקי',
    'gym.pricingTier4Members': 'מעל 1000 חברים',
    'gym.pricingByAgreement': 'לפי הסכם',
    'gym.pricingPerMonth': 'CHF לחודש',
    'gym.pricingPrice2': '250 CHF / חודש',
    'gym.pricingPrice3': '350 CHF / חודש',
    'gym.pricingPrice4': '500 CHF / חודש',
    'gym.pricingTerms': 'חידוש אוטומטי.',
    'gym.pricingCancelAnytime': 'ניתן לביטול בכל עת.',
    'gym.pricingPlatforms': 'זמין עבור',
    'gym.pricingAllFeatures': 'כל התכונות',
    'gym.pricingContactButton': 'צור קשר',
    'gym.allFeaturesTitle': 'כל התכונות',
    'gym.allFeatures1Title': 'רישום מקוון',
    'gym.allFeatures1Item1': 'רישום באתר האינטרנט שלך',
    'gym.allFeatures1Item2': 'רישום יחיד, זוגי ומשפחתי',
    'gym.allFeatures2Title': 'הגדרות וקונפיגורציית מערכת',
    'gym.allFeatures2Item1': 'עיצוב מותאם אישית',
    'gym.allFeatures2Item2': 'קונפיגורציית SMTP',
    'gym.allFeatures2Item3': 'הגדרות חשבון בנק',
    'gym.allFeatures2Item4': 'ניהול צוות',
    'gym.allFeatures2Item5': 'קונפיגורציית מנוי',
    'gym.allFeatures2Item6': 'פריטי חיוב',
    'gym.allFeatures2Item7': 'תבניות מסמכים',
    'gym.allFeatures2Item8': 'תבניות טקסט ודוא"ל',
    'gym.allFeatures3Title': 'לוח בקרה, ניתוחים וייצוא',
    'gym.allFeatures3Item1': 'ייצוא Excel',
    'gym.allFeatures3Item2': 'תרשימי הכנסות, תשלומים ולקוחות',
    'gym.allFeatures3Item3': 'סקירת תשלומים ממתינים',
    'gym.allFeatures4Title': 'ניהול חברים',
    'gym.allFeatures4Item1': 'רשימת חברים עם אפשרויות סינון',
    'gym.allFeatures4Item2': 'יצירת חברים ידנית',
    'gym.allFeatures4Item3': 'תצוגת פרטים עם מנויים, חשבוניות, תשלומים ומסמכים',
    'gym.allFeatures4Item4': 'היסטוריית שינויים',
    'gym.allFeatures5Title': 'ניהול מנויים / חוזים',
    'gym.allFeatures5Item1': 'יצירת חוזה אוטומטית וידנית עם דוא"ל',
    'gym.allFeatures5Item2': 'חיוב אוטומטי וידני',
    'gym.allFeatures5Item3': 'שינויי סטטוס',
    'gym.allFeatures5Item4': 'אפשרויות השהיה עם חידוש אוטומטי',
    'gym.allFeatures6Title': 'הנהלת חשבונות',
    'gym.allFeatures6Item1': 'טבלאות חשבוניות לקוח וגלובליות',
    'gym.allFeatures6Item2': 'חיוב ידני/אוטומטי עם שליחה',
    'gym.allFeatures6Item3': 'חשבוניות מותאמות אישית',
    'gym.allFeatures6Item4': 'תמיכה בתשלומים בתשלומים',
    'gym.allFeatures6Item5': 'עד 3 רמות תזכורת',
    'gym.allFeatures6Item6': 'הזנת תשלום ידנית',
    'gym.allFeatures6Item7': 'חשבוניות ניתנות לשינוי/הנפקה מחדש',
    'gym.allFeatures6Item8': 'חשבוניות QR לבנקים שוויצרים',
    'gym.allFeatures6Item9': 'חיוב לפי 595',
    'gym.allFeatures7Title': 'ניהול מסמכים',
    'gym.allFeatures7Item1': 'יצירת מסמכים אוטומטית',
    'gym.allFeatures7Item2': 'העלאות מותאמות אישית',
    'gym.allFeatures7Item3': 'יצירת תבניות',
    'gym.allFeatures7Item4': 'תצוגה מקדימה של PDF/JPG/PNG',
    'gym.allFeatures8Title': 'התאמת בנק אוטומטית',
    'gym.allFeatures8Item1': 'העלאת קובץ CAMT',
    'gym.allFeatures8Item2': 'הקצאת תשלום אוטומטית לפי מספר אסמכתא',
    'gym.allFeatures8Item3': 'מבטל עבודה ידנית',
    'gym.allFeatures9Title': 'בקרת כניסה 24/7',
    'gym.allFeatures9Item1': 'כרטיסי חבר דיגיטליים',
    'gym.allFeatures9Item2': 'מעקב נוכחות אוטומטי',
    'gym.allFeatures9Item3': 'אינטגרציה עם מערכות בקרת גישה כמו שערי סיבוב, דלתות, RFID, NFC',
    'gym.allFeatures9Item4': 'אידיאלי לפעילות חדר כושר 24 שעות',
    'gym.tarif595FaqTitle': 'Tarif 595 FAQ',
    'gym.tarif595FaqSubtitle': 'תשובות מרכזיות על תקן החשבוניות החדש לחדרי כושר בשווייץ.',
    'gym.tarif595FeaturedQuestion': 'האם צריך כלים חיצוניים למסמכי Tarif 595?',
    'gym.tarif595FeaturedAnswer': 'לא. המסמכים נוצרים ישירות בתוכנת Initso Gym Software - ללא מעבר בין מערכות.',
    'gym.tarif595Faq1Question': 'מה משתנה עבורכם?',
    'gym.tarif595Faq1Answer': 'החל מ-1 בינואר 2027 שירותי כושר לקידום בריאות ייבדקו על ידי חברות הביטוח לפי Tarif 595 ובאמצעות מסמך החזר אחיד. במקום האישורים הקודמים, החברים יצטרכו מסמך מובנה הכולל נכון את פרטי החובה לפי הסכמה של Tarif 595.',
    'gym.tarif595Faq2Question': 'מהו Tarif 595?',
    'gym.tarif595Faq2Answer': 'Tarif 595 הוא תעריף שווייצרי לשירותים אמבולטוריים לקידום בריאות במסגרת ביטוחים משלימים. משנת 2027 הוא רלוונטי גם לחדרי כושר ולספקים דומים, כדי שניתן יהיה להגיש שירותים לחברות ביטוח בצורה ברורה ואחידה.',
    'gym.tarif595Faq5Question': 'איך אפשר להשתמש בתעריף במערכת INITSO Gym?',
    'gym.tarif595Faq5Answer': 'INITSO משלבת את הפונקציה הזו בתוכנת חדר הכושר ויוצרת אוטומטית מסמך Tarif 595 שניתן לשלוח ללקוח ישירות ממערכת INITSO.',
    'gym.tarif595Faq6Question': 'מתי פונקציית Tarif 595 תהיה זמינה?',
    'gym.tarif595Faq6Answer': 'יצירת מסמכי החזר לפי Tarif 595 תופעל אוטומטית במערכת החל מ-01.01.2027, כדי שהסטודיו יוכל להשתמש בתקן החדש ברגע שהוא הופך למחייב.',
    'gym.tarif595Faq7Question': 'מה קורה לאישורי המנוי וההשתתפות הקודמים?',
    'gym.tarif595Faq7Answer': 'משנת 2027 אישורי השתתפות קודמים כבר לא יספיקו לחיוב מול חברות ביטוח. במקום זאת יש להשתמש במסמך ההחזר לפי Tarif 595.',
    'gym.tarif595Faq8Question': 'איך אפשר ללמוד עוד על INITSO Gym ועל Tarif 595?',
    'gym.tarif595Faq8Answer': 'מלאו את טופס יצירת הקשר למטה כדי לקבל ייעוץ חינם.',
    // Basic translations for other product pages
    'property.title': 'פרופרטי פרופי',
    'property.subtitle': 'ניהול נכסים קל. עם הכלי המבוסס על ענן שלנו יש לך את כל המידע מובנה זמין וכל המשימות שלך תחת שליטה.',
    'web.title': 'אתרים וחנויות אינטרנט',
    'web.subtitle': 'הנתונים שלך, ההצלחה שלך - שחרר את הפוטנציאל שלך. מומחי עיצוב אתרים יצירתיים, ניהול נתונים יעיל ואינטגרציה חלקה.',
    'portal.title': 'פורטל לקוחות',
    'portal.subtitle': 'כל העסקאות של השותפים העסקיים שלך והזמנות הלקוחות בכלי ענן ברור ובטוח.',
    'property.mainFeatures': 'תכונות מרכזיות',
    'property.featuresDescription': 'PropertyProfi מספק את כל הכלים הדרושים לניהול נכסים יעיל.',
    'property.crmSystem': 'מערכת CRM',
    'property.crmSystemDesc': 'נהל את כל הלקוחות, הדיירים והשותפים העסקיים שלך במקום מרכזי אחד עם פרטי קשר והיסטוריית תקשורת.',
    'property.propertyManagement': 'ניהול נכסים',
    'property.propertyManagementDesc': 'ארגן את כל הנכסים שלך בצורה מובנית עם מידע מפורט על נכסים, יחידות וקשרי שכירות.',
    'property.accounting': 'הנהלת חשבונות',
    'property.accountingDesc': 'פונקציות הנהלת חשבונות משולבות לניהול חלק של ההיבטים הפיננסיים של הנכסים שלך.',
    'property.documentArchive': 'ארכיון מסמכים',
    'property.documentArchiveDesc': 'שמירה מאובטחת של כל המסמכים החשובים עם קטגוריות חכמות וחיפוש מהיר.',
    'property.insuranceManagement': 'ניהול ביטוחים',
    'property.insuranceManagementDesc': 'ניהול ברור של כל הביטוחים עם תזכורות אוטומטיות לחידושים ותשלומים.',
    'property.reportingAnalytics': 'דוחות וניתוחים',
    'property.reportingAnalyticsDesc': 'דוחות וניתוחים מקיפים על רווחיות וביצועי תיקי הנדלן שלך.',
    'property.showcaseTitle': 'PropertyProfi בפעולה',
    'property.showcase1Title': 'סקירת דשבורד',
    'property.showcase1Desc': 'סקירה מרכזית של כל הנכסים שלך עם מדדים חשובים ופעילויות עדכניות במבט אחד.',
    'property.showcase2Title': 'ניהול פיננסי',
    'property.showcase2Desc': 'פונקציות הנהלת חשבונות מקיפות לניהול כל ההיבטים הפיננסיים של תיקי הנדלן שלך.',
    'property.showcase3Title': 'ניהול מסמכים',
    'property.showcase3Desc': 'שמירה מאובטחת ומסודרת של כל המסמכים החשובים עם פונקציית חיפוש חכמה.',
    'property.whyPropertyProfi': 'למה PropertyProfi?',
    'property.cloudBased': 'מבוסס ענן',
    'property.cloudBasedDesc': 'גישה לנתונים שלך מכל מקום ובכל זמן - בצורה מאובטחת ואמינה.',
    'property.userFriendly': 'ידידותי למשתמש',
    'property.userFriendlyDesc': 'שימוש אינטואיטיבי ללא זמן הכשרה ארוך - מוכן לעבודה מיד.',
    'property.scalable': 'מדרגי',
    'property.scalableDesc': 'גדל יחד עם העסק שלך - מנכסים בודדים ועד תיקי נכסים גדולים.',
    'property.swissQuality': 'איכות שוויצרית',
    'property.swissQualityDesc': 'פותח בשווייץ לפי סטנדרטים גבוהים של פרטיות ואבטחת מידע.',
    'property.readyForPropertyProfi': 'מוכן ל-PropertyProfi?',
    'property.readyForPropertyProfiDesc': 'צור קשר להדגמה אישית וגלה כיצד PropertyProfi יכול לשנות את ניהול הנכסים שלך.',
    'property.contactNow': 'צור קשר עכשיו',
    'web.ourWebServices': 'שירותי הווב שלנו',
    'web.webServicesDesc': 'מהעיצוב היצירתי ועד היישום הטכני - אנו מספקים את כל מה שצריך לנוכחות מקוונת מוצלחת.',
    'web.creativeWebDesign': 'עיצוב אתרים יצירתי',
    'web.creativeWebDesignDesc': 'עיצובים מותאמים ומושכים שמשקפים את המותג שלך ומדברים לקהל היעד שלך.',
    'web.customSolutions': 'פתרונות מותאמים אישית',
    'web.customSolutionsDesc': 'כל אתר מפותח במיוחד לפי הדרישות שלך - בלי תבניות, אלא התאמה אמיתית.',
    'web.efficientDataManagement': 'ניהול נתונים יעיל',
    'web.efficientDataManagementDesc': 'מבני נתונים חכמים ומערכות ניהול תוכן שמאפשרים ניהול פשוט של התוכן שלך.',
    'web.apiConnections': 'חיבורי API',
    'web.apiConnectionsDesc': 'אינטגרציה חלקה של מערכות צד שלישי ומערכות תשלום להרחבת יכולות האתר.',
    'web.responsiveDesign': 'עיצוב רספונסיבי',
    'web.responsiveDesignDesc': 'תצוגה מושלמת בכל המכשירים - ממחשב שולחני ועד סמארטפון.',
    'web.ecommerceIntegration': 'אינטגרציית מסחר אלקטרוני',
    'web.ecommerceIntegrationDesc': 'פתרונות חנות מקוונת מלאים עם מערכות תשלום מאובטחות וניהול מלאי.',
    'web.showcaseTitle': 'פרויקטי הווב שלנו',
    'web.showcase1Title': 'עיצוב אתרים רספונסיבי',
    'web.showcase1Desc': 'אתרים מודרניים ורספונסיביים שפועלים היטב בכל המכשירים.',
    'web.showcase2Title': 'פתרונות מסחר אלקטרוני',
    'web.showcase2Desc': 'פיתוח חנויות מקוונות מקצועיות עם מערכות תשלום מאובטחות וניהול מוצרים מקיף.',
    'web.showcase3Title': 'ויזואליזציית נתונים',
    'web.showcase3Desc': 'דשבורדים ודוחות אינטראקטיביים להצגה ברורה של הנתונים העסקיים שלך.',
    'web.ourDevelopmentProcess': 'תהליך הפיתוח שלנו',
    'web.needsAnalysis': 'ניתוח צרכים',
    'web.needsAnalysisDesc': 'אנו מנתחים את הדרישות שלך ומפתחים יחד את הקונספט המתאים ביותר.',
    'web.designPrototyping': 'עיצוב ואב טיפוס',
    'web.designPrototypingDesc': 'יצירת מוקפים ואבות טיפוס לקבלת תמונה ברורה של התוצאה הסופית.',
    'web.development': 'פיתוח',
    'web.developmentDesc': 'יישום מקצועי עם טכנולוגיות מודרניות וסטנדרטים גבוהים של איכות.',
    'web.launchSupport': 'השקה ותמיכה',
    'web.launchSupportDesc': 'עלייה מוצלחת לאוויר עם תמיכה וליווי מתמשך לאחר מכן.',
    'web.readyForNewWebPresence': 'מוכן לנוכחות ווב חדשה?',
    'web.readyForNewWebPresenceDesc': 'בוא נממש יחד את החזון שלך. צור קשר לשיחת ייעוץ לא מחייבת.',
    'web.discussProject': 'לדבר על הפרויקט',
    'portal.portalFeatures': 'תכונות הפורטל',
    'portal.portalFeaturesDesc': 'פורטל הלקוחות שלנו מספק פלטפורמה מרכזית לכל התהליכים העסקיים והאינטראקציות עם לקוחות.',
    'portal.efficientApplicationProcessing': 'עיבוד בקשות יעיל',
    'portal.efficientApplicationProcessingDesc': 'ייעל את עיבוד הבקשות שלך עם תהליכי עבודה אוטומטיים וניהול מסמכים דיגיטלי.',
    'portal.dataVisualization': 'ויזואליזציית נתונים',
    'portal.dataVisualizationDesc': 'דשבורדים ודוחות חכמים לקבלת החלטות טובה יותר על בסיס נתונים בזמן אמת.',
    'portal.competentCustomerService': 'שירות לקוחות מקצועי',
    'portal.competentCustomerServiceDesc': 'כלי תקשורת ומערכת כרטיסים משולבים לשירות לקוחות ותמיכה ברמה גבוהה.',
    'portal.increaseProductivity': 'הגברת פרודוקטיביות',
    'portal.increaseProductivityDesc': 'אוטומציה של משימות חוזרות ותהליכי עבודה מותאמים ליעילות מקסימלית.',
    'portal.secureDataProcessing': 'עיבוד נתונים מאובטח',
    'portal.secureDataProcessingDesc': 'סטנדרטי אבטחה גבוהים ועמידה בדרישות פרטיות למערכת עסקית אמינה.',
    'portal.userFriendlyInterface': 'ממשק ידידותי למשתמש',
    'portal.userFriendlyInterfaceDesc': 'שימוש אינטואיטיבי ודשבורדים ניתנים להתאמה לחוויית משתמש מיטבית.',
    'portal.showcaseTitle': 'תכונות הפורטל בפירוט',
    'portal.showcase1Title': 'דשבורד משתמש',
    'portal.showcase1Desc': 'ממשק משתמש אינטואיטיבי עם דשבורדים ניתנים להתאמה לחוויית משתמש מיטבית.',
    'portal.showcase2Title': 'ניהול תהליכי עבודה',
    'portal.showcase2Desc': 'תהליכים אוטומטיים וניהול תהליכי עבודה יעיל לפרודוקטיביות מקסימלית.',
    'portal.showcase3Title': 'עיבוד נתונים מאובטח',
    'portal.showcase3Desc': 'סטנדרטי אבטחה גבוהים ועיבוד נתונים תואם פרטיות לשיתוף פעולה אמין.',
    'portal.advantagesOfOurPortal': 'יתרונות הפורטל שלנו',
    'portal.centralizedManagement': 'ניהול מרכזי',
    'portal.centralizedManagementDesc': 'כל המידע והתהליכים החשובים במקום אחד.',
    'portal.realtimeSynchronization': 'סנכרון בזמן אמת',
    'portal.realtimeSynchronizationDesc': 'נתונים עדכניים וזמינים לכל המשתמשים המורשים.',
    'portal.scalableArchitecture': 'ארכיטקטורה מדרגית',
    'portal.scalableArchitectureDesc': 'פתרון שגדל עם העסק והדרישות שלך.',
    'portal.customizableWorkflows': 'תהליכי עבודה מותאמים',
    'portal.customizableWorkflowsDesc': 'התאמה מדויקת לתהליכים הפנימיים ולצרכי הלקוחות שלך.',
    'portal.readyForYourOwnPortal': 'מוכן לפורטל משלך?',
    'portal.readyForYourOwnPortalDesc': 'צור קשר להדגמה אישית וגלה כיצד פורטל לקוחות יכול לייעל את התהליכים שלך.',
    'portal.requestPortalDemo': 'בקש הדגמת פורטל',
    // Contact Form
    'contactForm.title': 'צור קשר',
    'contactForm.description': 'יש לך שאלות על {productName}? צור קשר עבור מידע נוסף או יעוץ אישי.',
    'contactForm.yourInquiry': 'הפנייה שלך על {productName}',
    'contactForm.name': 'שם *',
    'contactForm.email': 'אימייל *',
    'contactForm.message': 'הודעה *',
    'contactForm.messagePlaceholder': 'אני מעוניין ב-{productName} ואשמח למידע נוסף...',
    'contactForm.sendMessage': 'שלח הודעה',
    'contactForm.sending': 'שולח...',
    'contactForm.messageSent': 'הודעה נשלחה',
    'contactForm.thankYou': 'תודה על פנייתך. נחזור אליך בקרוב!',
    'contactForm.error': 'שגיאה',
    'contactForm.errorMessage': 'אירעה שגיאה בשליחת ההודעה שלך. אנא נסה שוב.',
  // Blog
  'blog.title': 'בלוג',
  'blog.subtitle': 'תובנות, ידע מעשי וחדשות על תוכנה, דיגיטציה ו-INITSO.',
  'blog.loading': 'טוען פוסטים',
  'blog.loadError': 'לא ניתן לטעון את הפוסטים. אנא נסו שוב מאוחר יותר.',
  'blog.unavailable': 'הבלוג אינו זמין',
  'blog.empty': 'עדיין לא פורסמו פוסטים',
  'blog.readMore': 'לקריאת הפוסט',
  'blog.pagination': 'עמודי הבלוג',
  'blog.previous': 'העמוד הקודם',
  'blog.next': 'העמוד הבא',
  'blog.backToOverview': 'חזרה לבלוג',
  'blog.notFoundTitle': 'הפוסט לא נמצא',
  'blog.notFoundDescription': 'הפוסט המבוקש אינו קיים או הוסר.',
  // Buttons
  'buttons.login': 'התחברות',
  'buttons.startTrial': 'נסיון חינם',
  // Team Roles
  'CEO': 'מנכ"ל',
  'CFO': 'סמנכ"ל כספים',
  'Chief Software Developer': 'מפתח תוכנה ראשי',
  'Chief Software Architect': 'אדריכל תוכנה ראשי',
  'Head Frontend Entwickler': 'ראש מפתחי Frontend',
  'Q&I Developer': 'מפתח Q&I',
  'Sales & Marketing': 'מכירות ושיווק'
} as const;
